import Vue from 'vue'
import router from './router'
import App from './App.vue'

import '@/styles/base.less' // global css
import '@/styles/index.less'
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

// iPadOS 可能以桌面 Mac 标识访问。其余平板按设备屏幕与触控能力判断，
// 不使用内嵌 WebView 的宽度，因为 iOS 的登录窗口比整块屏幕窄。
const userAgent = navigator.userAgent || ''
const hasTouchInput = navigator.maxTouchPoints > 0 ||
  window.matchMedia('(any-pointer: coarse)').matches
const isIPad = /iPad/i.test(userAgent) ||
  (navigator.platform === 'MacIntel' && hasTouchInput)
const isAndroidOrHarmony = /Android|HarmonyOS|OpenHarmony|HUAWEI|HONOR/i.test(userAgent)
const shortScreenSide = Math.min(window.screen.width, window.screen.height)
const viewportWidth = document.documentElement.clientWidth || window.innerWidth
const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight
const compactViewportRatio = viewportHeight / viewportWidth
// App 内嵌小窗口可能无法正确报告整机屏幕尺寸，补充识别接近方形的触控视窗。
const isCompactTouchWindow = hasTouchInput &&
  viewportWidth <= 700 && viewportHeight <= 700 &&
  compactViewportRatio >= 0.75 && compactViewportRatio <= 1.35
const isPad = isIPad ||
  (shortScreenSide >= 600 && (hasTouchInput || isAndroidOrHarmony)) ||
  isCompactTouchWindow
const padPreviewPlatform = new URLSearchParams(window.location.search).get('padPreview')
const padPreview = process.env.NODE_ENV === 'development' && padPreviewPlatform !== null
if (isPad || padPreview) {
  const padPlatform = padPreview && ['ios', 'android'].includes(padPreviewPlatform)
    ? padPreviewPlatform
    : (isIPad ? 'ios' : 'android')
  document.documentElement.classList.add('pad-login', `pad-${padPlatform}`)

  if (padPlatform === 'ios') {
    // Safari 的页面缩放和 App 内弹窗都会改变可见视窗，按实际可见尺寸计算布局。
    const updateIosViewport = () => {
      const visualViewport = window.visualViewport
      const width = (visualViewport && visualViewport.width) || window.innerWidth
      const height = (visualViewport && visualViewport.height) || window.innerHeight
      const root = document.documentElement

      root.style.setProperty('--pad-ios-viewport-width', `${width}px`)
      root.style.setProperty('--pad-ios-viewport-height', `${height}px`)

      // 键盘弹出时保留原有字号，避免输入过程中整页忽然缩小。
      if (!document.activeElement || !/^(INPUT|TEXTAREA)$/.test(document.activeElement.tagName)) {
        root.style.setProperty('--pad-ios-font-size', `${Math.min(50, width * 0.08, height * 0.08)}px`)
      }
    }

    updateIosViewport()
    window.addEventListener('resize', updateIosViewport)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateIosViewport)
    }
  }
}

import { isMobile, loginCb, checkBtn } from '@/utils/base'
Vue.prototype.$isMobile = isMobile
Vue.prototype.$loginCb = loginCb
Vue.prototype.$checkBtn = checkBtn

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title + ' - 研途教育'
  }
  if (to.query.backpath) {
    sessionStorage.setItem('backpath', to.query.backpath)
  }
  //存在tq直接存储；tq_id 存储整个链接
  // tq为存在tq_id的链接
  // tq_id为单独的id
  if (
    to.query.tq ||
    to.query.tq_id ||
    RegExp(/tq_id/).test(to.query.backpath)
  ) {
    sessionStorage.setItem(
      "tq",
      encodeURIComponent(
        to.query.tq || to.query.backpath || encodeURIComponent(location.href)
      )
    );
  }
  let toKeys = Object.keys(to.query).length
  let fromKeys = Object.keys(from.query).length
  if (fromKeys && !toKeys) {
    next({
      path: to.path,
      query: { ...from.query },
    })
  } else {
    next()
  }
})

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
